import routes from "../../routing/routes";
import {LAYOUT_DASHBOARD, LAYOUT_DEFAULT} from "../Layout";


export default function getLayoutType(path) {
    switch (path) {
        case routes.dashboard.path:
        case routes.user_management.path:
        case routes.image_management.path:
        case routes.video_management.path:
        case routes.audio_management.path:
        case routes.document_management.path:
        case routes.banner_management.path:
        case routes.article_management.path:
        case routes.promotion_management.path:
        case routes.combo_management.path:
        case routes.course_management.path:
        case routes.chapter_management.path:
        case routes.lesson_management.path:
        case routes.quiz_management.path:
        case routes.enrollment_management.path:
            return LAYOUT_DASHBOARD;
        default:
            return LAYOUT_DEFAULT;
    }
}
